<div class="d-flex justify-content-center align-items-center pt-4" *ngIf="documents">
    <ng-container *ngIf="documents?.length === 0; else documentsTableTemplate">
        <div class="mt-4 d-flex text-center flex-column align-items-center">
            <mat-icon class="no-results-icon">file_copy_off</mat-icon>
            <h4 class="no-docs-text">Non ci sono documenti da caricare</h4>
        </div>
    </ng-container>
    <ng-template #documentsTableTemplate>
        <table aria-label="document-upload-table" class="table mt-3">
            <thead class="bg-light">
                <tr>
                    <th scope="col">Documento</th>
                    <th scope="col">Download</th>
                    <th scope="col">Upload</th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let document of documents">
                    <tr *ngIf="!document?.providedFromCompany">
                        <td>
                            <h6>{{ document.descrizioneDocumento }} <span *ngIf="document.isMandatory">*</span></h6>
                        </td>
                        <td>
                            <ng-container *ngIf="document.isUploaded && !isCancelOperation">
                                <mat-icon class="download-icon" aria-hidden="false" aria fontIcon="download" (click)="downloadDocument(document)"></mat-icon>
                            </ng-container>
                        </td>
                        <td>
                            <mat-icon class="download-icon" aria-hidden="false" aria fontIcon="upload" (click)="fileInput.click()" *ngIf="(!isAlreadySubmitted || !document.isUploaded) && !isHelpDeskAccount"></mat-icon>
                            <input #fileInput type="file" (change)="onSelectFile(document, $event)" style="display:none" />
                        </td>
                        <td>
                            <span class="badge badge-green" *ngIf="document.isUploaded">Caricato</span>
                            <span class="badge badge-red" *ngIf="!document.isUploaded">Da caricare</span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </ng-template>
</div>
